export const indexedDbGetObjectStore = (
  db: IDBDatabase | undefined,
  objectStoreName: string,
): IDBObjectStore | undefined => {
  return db?.transaction(objectStoreName, "readwrite").objectStore(objectStoreName);
};

export const indexedDbAddStore = (db: IDBDatabase | undefined, objectStoreName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      if (!!db) {
        db.createObjectStore(objectStoreName);
        resolve("");
      } else {
        reject("missing DB");
      }
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
};

export const indexedDbDeleteStore = (db: IDBDatabase | undefined, objectStoreName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    try {
      if (!!db) {
        db.deleteObjectStore(objectStoreName);
        resolve("");
      } else {
        reject("missing DB");
      }
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
};

export const indexedDbAddData = (
  db: IDBDatabase | undefined,
  objectStoreName: string,
  data: any,
  key?: IDBValidKey,
): Promise<IDBValidKey> => {
  return new Promise((resolve, reject) => {
    const objectStore: IDBObjectStore | undefined = indexedDbGetObjectStore(db, objectStoreName);
    if (!objectStore) {
      reject("Could not find object store");
    } else {
      const request = objectStore.add(data, key);
      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = (error) => {
        reject(error);
      };
    }
  });
};

export const indexedDbGetData = (
  db: IDBDatabase | undefined,
  objectStoreName: string,
  key: IDBValidKey | IDBKeyRange,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const objectStore: IDBObjectStore | undefined = indexedDbGetObjectStore(db, objectStoreName);
    if (!objectStore) {
      reject("Could not find object store");
    } else {
      const request = objectStore.get(key);
      request.onsuccess = () => {
        resolve(request.result);
      };

      request.onerror = (error) => {
        reject(error);
      };
    }
  });
};

export const indexedDbGetAllData = async (db: IDBDatabase | undefined, objectStoreName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const objectStore: IDBObjectStore | undefined = indexedDbGetObjectStore(db, objectStoreName);
    if (!objectStore) {
      reject("Could not find object store");
    } else {
      const allKeysRequest: IDBRequest<IDBValidKey[]> = objectStore.getAllKeys();
      allKeysRequest.onsuccess = async () => {
        try {
          const result = await indexedDbGetData(db, objectStoreName, allKeysRequest.result);
          resolve(result);
        } catch (e) {
          reject(e);
        }
      };

      allKeysRequest.onerror = (e) => {
        console.error(e);
        reject(e);
      };
    }
  });
};

export const indexedDbDeleteData = async (
  db: IDBDatabase | undefined,
  objectStoreName: string,
  key: IDBValidKey | IDBKeyRange,
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const objectStore: IDBObjectStore | undefined = indexedDbGetObjectStore(db, objectStoreName);
    if (!objectStore) {
      reject("Could not find object store");
    } else {
      const deleteRequest = objectStore.delete(key);

      deleteRequest.onsuccess = () => {
        resolve(`Successfully deleted data from store ${objectStoreName} for keys: ${key}`);
      };

      deleteRequest.onerror = (e) => {
        console.error(e);
        reject(e);
      };
    }
  });
};

export const indexedDbDeleteAllData = async (db: IDBDatabase | undefined, objectStoreName: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    const objectStore: IDBObjectStore | undefined = indexedDbGetObjectStore(db, objectStoreName);
    if (!objectStore) {
      reject("Could not find object store");
    } else {
      const allKeysRequest: IDBRequest<IDBValidKey[]> = objectStore.getAllKeys();
      allKeysRequest.onsuccess = async () => {
        try {
          await indexedDbDeleteData(db, objectStoreName, allKeysRequest.result);
          resolve("Successfully deleted all keys");
        } catch (e) {
          reject(e);
        }
      };

      allKeysRequest.onerror = (e) => {
        console.error(e);
        reject(e);
      };
    }
  });
};
